import { IPayService } from "./pay.types";
import { IPayRepository } from "@/repositories";
import { Amex, IVPlusData, Pay } from "@/entities";
import loadScript from "@/utils/loadScript"
import { SOURCE_AMEX, SOURCE_AMEX_V2, SOURCE_MASTERCARD_SESSION, SOURCE_MASTERCARD_3DS } from "@/utils/domain"
import { IOrder } from "@/entities/order/order";

export class PayService implements IPayService {
    private mastercardScripts?: Promise<any>;
    constructor(private repository: IPayRepository) { }
    async payByCreditCard(orderId: string): Promise<Pay | undefined> {
        return this.repository.creditcardReq(orderId);
    }
    async payByOther(orderId: string): Promise<Pay | undefined> {
        return this.repository.APMReq(orderId);
    }
    async payByAmex(orderId: string): Promise<Amex | undefined> {
        return this.repository.AMEXReq(orderId);
    }
    async payByAmexV2(orderId: string, amount: number): Promise<Amex | undefined> {
        return this.repository.AMEXV2Req(orderId, amount);
    }
    async configureAmexScript(): Promise<any> {
        return loadScript(SOURCE_AMEX);
    }
    async configureAmexV2Script(): Promise<any> {
        return loadScript(SOURCE_AMEX_V2);
    }
    async configureMastercardCardScripts(): Promise<any> {
        // the page starts this when Amex is selected and the dialog awaits the same promise,
        // so the gateway scripts are fetched once and never raced against
        if (!this.mastercardScripts) {
            this.mastercardScripts = Promise.all([
                loadScript(SOURCE_MASTERCARD_SESSION),
                loadScript(SOURCE_MASTERCARD_3DS),
            ]).catch((error) => {
                this.mastercardScripts = undefined;
                throw error;
            });
        }
        return this.mastercardScripts;
    }
    async initCardPayment(payload: Record<string, string | number>, token: string): Promise<any> {
        return this.repository.CardPaymentInit(payload, token);
    }
    async payCardPayment(payload: Record<string, string | number | boolean>, token: string): Promise<any> {
        return this.repository.CardPaymentPay(payload, token);
    }
    async payByVplus(orderId: string, mobile: string): Promise<IVPlusData | undefined> {
        return this.repository.WalletReq(orderId, mobile);
    }
    async payAtStore(orderId: string, payload: any): Promise<any> {
        return this.repository.PayAtStore(orderId, payload);
    }
    async createKBankQrPayment(orderId: string, type: string, amount: number, token: string): Promise<any> {
        return this.repository.CreateKBankQrPayment(orderId, type, amount, token);
    }
    async generateQRWalletPayment(payload: Record<string, string | number>, token: string): Promise<any> {
        return this.repository.GenerateQRWalletPayment(payload, token);
    }

    async inquireQRWalletPayment(paymentId: string, token: string): Promise<any> {
        return this.repository.InquireQRWalletPayment(paymentId, token);
    }
}